import { isWithinRange } from '@common/utils/date/isWithinRange'
import type { HelloBarInitialData } from '../../content/components/helloBar/helloBarInitialData'

export interface GlobalElementInitialData extends HelloBarInitialData {
    enabledSiteIdsForTransactionFlows?: string[]
}

export function getSingleGlobalElementId(path: string, initHelloBars: GlobalElementInitialData[]): number | undefined {
    if (!(initHelloBars?.length > 0)) return
    const sanitisedHelloBars = initHelloBars.map(helloBar => {
        return {
            ...helloBar,
            pageRules: helloBar?.pageRules?.map(rule => {
                return rule.replace(/\*/g, '.')
            }),
        }
    })

    const activeHelloBar = sanitisedHelloBars?.find(helloBar => {
        const matchThePath = helloBar?.pageRules?.some(rule => {
            if (rule.indexOf('.') === -1) {
                return path.match(new RegExp(`^${rule}$`))
            } else if (rule.indexOf('.') !== -1) {
                return path.match(new RegExp(`^${rule.replace('.', '.+')}`))
            } else {
                return path.match(new RegExp(`^${rule}$`)) // Handle other rules as needed
            }
        })
        return matchThePath && isWithinRange(helloBar.startTime, helloBar.endTime)
    })

    return activeHelloBar?.id
}
